var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    fillRule: "evenodd",
    d: "M17.75 17.157a6.75 6.75 0 0 1-4.426 1.649c-3.769 0-6.824-3.09-6.824-6.903S9.555 5 13.324 5a6.75 6.75 0 0 1 4.426 1.649A6.75 6.75 0 0 1 22.176 5C25.945 5 29 8.09 29 11.903s-3.055 6.903-6.824 6.903a6.75 6.75 0 0 1-4.426-1.65",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    fillRule: "evenodd",
    d: "M17.75 17.157a6.92 6.92 0 0 0 2.398-5.254 6.92 6.92 0 0 0-2.398-5.254A6.75 6.75 0 0 1 22.176 5C25.945 5 29 8.09 29 11.903s-3.055 6.903-6.824 6.903a6.75 6.75 0 0 1-4.426-1.65",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    fillRule: "evenodd",
    d: "M17.75 17.157a6.92 6.92 0 0 0 2.398-5.254 6.92 6.92 0 0 0-2.398-5.254 6.92 6.92 0 0 0-2.398 5.254 6.92 6.92 0 0 0 2.398 5.254",
    clipRule: "evenodd"
  })));
};
export { SvgMastercard as ReactComponent };
export default "/_next/static/media/src/components/Layouts/AppLayout/Footer/assets/mastercard.d793e80591f8201ab60dbe013e159fc8.svg";